
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
class TipsPopup extends Vue {
  // 标题
  @Prop({ default: '提示' }) title!: string

  // 纯文本内容
  @Prop({ default: '' }) content!: string

  // HTML内容（优先级高于content）
  @Prop({ default: '' }) htmlContent!: string

  // 确认按钮文本
  @Prop({ default: '确认' }) confirmText!: string

  // 取消按钮文本
  @Prop({ default: '取消' }) cancelText!: string

  // 是否显示取消按钮
  @Prop({ default: true }) showCancel!: boolean

  // 确认按钮颜色
  @Prop({ default: '#3568D8' }) confirmColor!: string

  // 取消按钮颜色
  @Prop({ default: '#1D2129' }) cancelColor!: string

  // 点击遮罩层是否关闭
  @Prop({ default: false }) closeOnClickOverlay!: boolean

  visible = false
  // 业务参数
  popupParams: any = null

  get confirmBtnStyle() {
    return {
      color: this.confirmColor
    }
  }

  get cancelBtnStyle() {
    return {
      color: this.cancelColor
    }
  }

  /**
   * 显示弹窗
   * @param params 业务参数，会在confirm/cancel时回传
   * @param bool 是否显示
   */
  showPopup(params: any = null, bool = true) {
    this.popupParams = params
    this.visible = bool
  }

  // 取消
  onCancel() {
    this.visible = false
    this.$emit('cancel', this.popupParams)
  }

  // 确认
  onConfirm() {
    this.visible = false
    this.$emit('confirm', this.popupParams)
  }

  // 弹窗关闭动画结束后
  onClosed() {
    this.$emit('closed')
  }
}
export default TipsPopup
